import { connectHits } from 'react-instantsearch-dom';
import { arrayOf, object, func } from 'prop-types';
import { useFeatureFlags } from 'hooks';
import { computeMainCategoryFromHits } from './CategoryDetector.utils';

const CategoryDetector = ({ hits, onCategoryDetected }) => {
    const [{ hasSpecificFilters }] = useFeatureFlags({
        hasSpecificFilters: 'relevance.specific.filter.abtest',
    });

    const mainCategory =
        hasSpecificFilters && computeMainCategoryFromHits(hits);

    if (mainCategory && Object.keys(mainCategory).length > 0) {
        onCategoryDetected(mainCategory);
    }

    return null;
};

CategoryDetector.propTypes = {
    hits: arrayOf(object),
    onCategoryDetected: func.isRequired,
};

CategoryDetector.defaultProps = {
    hits: [],
};

export default connectHits(CategoryDetector);
